<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        گزارش رزرو غذا
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="success"
        class="mb-1 float-right"
        target="_blank"
        :href="exportExcel"
      >
        <feather-icon
          icon="FileTextIcon"
          class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        v-b-toggle.filter-box
        variant="outline-primary"
        class="mb-1"
      >
        <feather-icon
          icon="FilterIcon"
          class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
        id="filter-box"
        class="mb-2"
      >
        <b-card class="border mb-0">
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label>واحد سازمانی:</label>
                <v-select
                  v-model="search.organization"
                  multiple
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="organizationList"
                  :reduce="organization => organization.id"
                  :close-on-select="false"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>وعده غذایی:</label>
                <v-select
                  v-model="search.meal"
                  multiple
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="mealList"
                  :reduce="meal => meal.id"
                  :close-on-select="false"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>نوع رزرو:</label>
                <v-select
                  v-model="search.type"
                  multiple
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="slug"
                  :options="typeList"
                  :reduce="type => type.name"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group
                label="از تاریخ"
                label-for="due-date"
              >
                <date-picker
                  v-model="search.fromDate"
                  type="date"
                  display-format="jDD jMMMM jYYYY"
                  format="YYYY-MM-DD"
                  clearable
                />

              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="تا تاریخ"
                label-for="due-date"
              >
                <date-picker
                  v-model="search.toDate"
                  type="date"
                  display-format="jDD jMMMM jYYYY"
                  :min="search.fromDate"
                  format="YYYY-MM-DD"
                  clearable
                />

              </b-form-group>
            </b-col>
          </b-row>

          <hr>
          <div class="demo-inline-spacing">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="primary"
              @click="advanceSearch"
            >
              اعمال جستجو
            </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-secondary"
              @click="clearSearch"
            >
              حذف فیلترها
            </b-button>
          </div>
        </b-card>
      </b-collapse>
      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
            :fields="fields"
            :items="items"
            hover
            striped
            responsive
            show-empty
            empty-text="رکوردی یافت نشد"
          />
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BPagination,
  BBadge, BAvatar, BTooltip,
  BButton, VBTooltip, BCollapse, BFormInput, BRow, BCol, BFormGroup, VBToggle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VSelect from 'vue-select'
import { doubleRaf, queryString } from '@/libs/utils'
import { debounce } from '@/libs/debounce'

export default {
  name: 'ReservationReport',
  components: {
    BFormGroup,
    BCol,
    BRow,
    BFormInput,
    BCollapse,
    VSelect,
    BTooltip,
    BAvatar,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BPagination,
    BBadge,
    BButton,

  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'date',
          label: 'تاریخ غذا',
        },
        {
          key: 'meal',
          label: 'وعده غذایی',
        },
        {
          key: 'name',
          label: 'نام',
        },
        {
          key: 'food',
          label: 'نام غذا',
        },

        {
          key: 'organization',
          label: 'واحد سازمانی',
        },
        {
          key: 'count',
          label: 'تعداد',
        },
        {
          key: 'bookAt',
          label: 'تاریخ رزرو',
        },
        {
          key: 'type',
          label: 'نوع',
        },
      ],
      onProgress: false,
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      search: {},
      organizationList: [],
      mealList: [],
      typeList: [
        {
          name: 'normal',
          slug: 'عادی',
        },
        {
          name: 'special',
          slug: 'خاص',
        },
      ],
    }
  },
  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}reservation-report?export-excel=1&${query}`
    },
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Reservation_Report',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getRequestsList()
      }
    },
    mainProcess(newValue, oldValue) {
      if (newValue !== null) {
        const process = this.processes.find(process => process.id === newValue)
        if (process) {
          this.childProcess = process.children

          if (process.children.length > 0) {
            if (process.children.length > 1) {
              this.childProcess = process.children
            }
            doubleRaf(() => {
              this.processId = process.children[0].id
            })
          }
        } else {
          this.childProcess = []
        }
      } else {
        this.childProcess = []
      }

      this.processId = null
    },

  },
  mounted() {
    this.getOrganization()
    this.getMeal()
    this.setSearchData()
  },
  methods: {
    async getRequestsList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true
      this.$http.get('reservation-report', {
        params: {
          ...currentQuery,
          ...this.search,
        },
      })
        .then(({ data }) => {
          if (data.status) {
            this.items = data.items
          } else {
            this.$bvToast.toast(data.message ?? 'لیست درخواست ها دریافت نشد', {
              title: 'خطای دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? error.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
    advanceSearch() {
      if (this.search.fromDate && this.search.toDate) {
        this.$router.replace({
          name: this.$route.name,
          query: {
            ...this.search,
          },
        })
          .then(() => {

          })
          .catch(() => {
          })
        this.getRequestsList()
        doubleRaf(() => {
          this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
        })
      } else {
        this.$bvToast.toast('تاریخ شروع و پایان الزامی است', {
          title: 'خطا در دریافت اطلاعات',
          toaster: 'b-toaster-top-right',
          variant: 'danger',
        })
      }
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
        .then(() => {
          this.getRequestsList()
        })
        .catch(() => {
        })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },

    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.searchUser(loading, search, this)
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    }, 400),
    getMeal() {
      this.$http.get('meals?result=all')
        .then(({ data }) => {
          if (data.status) {
            this.mealList = data.meals
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست وعده غذایی با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },

    getOrganization() {
      this.$http.get('organizations?result=all')
        .then(({ data }) => {
          if (data.status) {
            this.organizationList = data.organizations
          } else {
            this.$bvToast.toast(data.message ?? 'دریافت لیست نقش ها با خطا مواجه شد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
    },
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
  },

}
</script>

<style>

</style>
